import Users from '../UsersComponent.vue'

export default [
    {
        path: '/users',
        name: '/users',
        meta: { layout: 'mystagit' },
        component: Users,
    },
]